import { createAsyncThunk } from '@reduxjs/toolkit';
import UserApi from '@infrastructure/user-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getAllUsersWithoutPagination = createAsyncThunk('user/getAllUsersWithoutPagination', async (_, { rejectWithValue }) => {
    try {
        const response = await UserApi.getAllUsersWithoutPagination();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch users');
    }
});
export const getAllUsersPaginatedAsync = createAsyncThunk('user/getAllUsersPaginated', async (request, { rejectWithValue }) => {
    try {
        const response = await UserApi.getAllUsersPaginated(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createUserAsync = createAsyncThunk('user/create', async (request, { rejectWithValue }) => {
    try {
        const response = await UserApi.createUser(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserAsync = createAsyncThunk('user/update', async (request, { rejectWithValue }) => {
    try {
        const response = await UserApi.updateUser(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserWithRolesByIdAsync = createAsyncThunk('user/getUserById', async (userId, { rejectWithValue }) => {
    try {
        const response = await UserApi.getUserWithRolesById(userId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const toggleUserActiveAsync = createAsyncThunk('role/update-status', async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserApi.updateUserStatusApi(payload);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllUsersByCompany = createAsyncThunk('user/getAllUsersByCompany', async (companyIds, { rejectWithValue }) => {
    try {
        const response = await UserApi.getAllUsersByCompanyApi(companyIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch users by company');
    }
});
